import React, {useMemo} from 'react';
import {ThesaurusesGate} from 'services/thesaurus';
import {ThesaurusEdit} from 'feature/editThesaurus';
import type {ThesaurusEditContainerConfig} from './types';
import {useThesaurusEditContext} from './hooks/useThesaurusEditContext';

type Props = {
  onClose: () => Promise<void>;
  config?: ThesaurusEditContainerConfig;
};
export const ThesaurusEditContainer: React.FC<Props> = ({
  onClose: _,
  config = {
    enableDeactivatedValues: false,
  },
}) => {
  const {sourceField, setSourceValue, closeExtension} =
    useThesaurusEditContext();
  const {
    editKey,
    thesaurusIds,
    showCode,
    selectableNodeTypes,
    focusNodeCodeWithTimestamp,
    findAdditionalData,
  } = useMemo(
    () => ({
      editKey: `${sourceField?.fieldConfig?.thesaurusId ?? ''}:${sourceField?.fieldId ?? ''}`,
      thesaurusIds: sourceField?.fieldConfig?.thesaurusId
        ? [sourceField?.fieldConfig?.thesaurusId]
        : undefined,
      showCode: sourceField?.fieldConfig?.showCode,
      selectableNodeTypes: sourceField?.fieldConfig?.selectableNodeTypes,
      focusNodeCodeWithTimestamp:
        sourceField?.fieldConfig?.focusNodeCodeWithTimestamp,
      findAdditionalData: sourceField?.fieldConfig?.findAdditionalData,
    }),
    [sourceField?.fieldConfig, sourceField?.fieldId],
  );

  return (
    <ThesaurusesGate thesauruses={thesaurusIds}>
      {thesaurusIds ? (
        <ThesaurusEdit
          // Set key to force remount when thesaurusIds[0] change, e.g. switch between thema and emneord
          key={editKey}
          thesaurusId={thesaurusIds[0]}
          showCode={showCode}
          includeDeactivatedValues={config.enableDeactivatedValues}
          selectableNodeTypes={selectableNodeTypes}
          focusNodeCodeWithTimestamp={focusNodeCodeWithTimestamp}
          fieldConfig={sourceField?.fieldConfig}
          thesaurusValue={sourceField?.currentValue}
          onSetSourceValue={setSourceValue}
          onClose={closeExtension}
          findAdditionalData={findAdditionalData}
        />
      ) : null}
    </ThesaurusesGate>
  );
};
